import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const fetchResellerByDni = async (dni, context = {}) => {
  try {
    const fetchResellerByDniFn = httpsCallable(functions, 'fetchResellerByDniV2');
    const result = await fetchResellerByDniFn({
      dni,
      ...context,
      requestedApp: context.requestedApp || 'dealership_web',
    });
    if (result.data.success === 'yes') {
      return { status: 'found', data: result.data.data };
    }
    if (result.data.success === 'no') {
      return { status: 'not_found', data: null };
    }
    throw new Error('Respuesta inválida al buscar reventa por DNI');
  } catch (error) {
    console.error('Error buscando usuario por DNI:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
